import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import MemorizedSidebar from './components/sidebar/sidebar';
import { syncPageScrollOnRouteChange } from './utils/pageScroll';

const useAuth = () => {
    const { userId, loading, error } = useSelector((state) => state.auth);
    if (userId) {
        return true
    } else {
        return false
    }
}

const ProtectedRoutes = ({ handleNCClick }) => {
    const auth = useAuth()
    const location = useLocation();
    const isStandaloneBillView = location.pathname.includes('advance-payment-bill');

    useEffect(() => {
        syncPageScrollOnRouteChange();
        const retryId = window.setTimeout(syncPageScrollOnRouteChange, 150);
        return () => window.clearTimeout(retryId);
    }, [location.pathname, location.search, location.key]);

    const NCCallBack = (applicationId) => {
        handleNCClick(applicationId)
    }

    if (!auth) {
        return <Navigate to="/" />
    }

    if (isStandaloneBillView) {
        return <Outlet />;
    }

    return (
        <div
            className="app-main-layout"
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                width: '100%',
                flex: 1,
                minWidth: 0,
                minHeight: 0,
            }}
        >
            <MemorizedSidebar handleCallBack={NCCallBack} />
            <Outlet />
        </div>
    )
}
export default ProtectedRoutes;